import React, { useEffect } from "react";
import { App, ConfigProvider, Table } from "antd";
import { createRoot } from 'react-dom/client';
import { customTheme } from "common/customTheme";
import { EditableContextProvider } from "common/EditableContextProvider";
import { useCampaignsPlans } from "../Hooks/useCampaignsPlans";
import ErrorBox from "common/ErrorBox";

export default function Main({cat_user_id}) {
    const context = useCampaignsPlans(cat_user_id);

    useEffect(() => {
        context.updateToken().then( () => {
            Promise.all([
                context.fillItems(),
                context.campaigns.fill(),
                context.listContacts.fill(),
            ]);
        });
    }, []);

    return (
        <div>
            <EditableContextProvider data={{ context }} >
                <Table
                    title={() => (
                        <div className="d-flex justify-content-between">
                            <div className="px-3" style={{ fontSize: '1.25rem' }}>Envío masivo</div>
                            <div className="d-flex">
                                <button className="btn cat-btn-white ms-2"
                                    onClick={() => context.fillItems()}
                                >
                                    <i className="fas fa-rotate me-2"></i>
                                    Actualizar
                                </button>
                                <button className="btn cat-btn-orange mx-3"
                                    onClick={() => context.newItem()}
                                >
                                    <i className="fas fa-plus me-2"></i>
                                    Añadir Nuevo
                                </button>
                            </div>
                        </div>
                    )}
                    {...context.getTableProps()}
                />
                { context.modalBase.contextModal }
            </EditableContextProvider>
        </div>
    )
}

let main = document.getElementById('campaign-plans-main');

if (main) {
    let cat_user_id = main.dataset.catUserId;
    if(!main.root) { main.root = createRoot(main); }
    main.root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App >
                        <Main cat_user_id={cat_user_id} />
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
